var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountSetupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5826",
    "data-name": "Group 5826",
    transform: "translate(-1105 -742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5677",
    "data-name": "Group 5677",
    transform: "translate(-448 153)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_877",
    "data-name": "Ellipse 877",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(1553 589)",
    fill: "#f8e2d6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5823",
    "data-name": "Group 5823",
    transform: "translate(1119 754)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29188",
    "data-name": "Path 29188",
    d: "M13.5,7h-3c-1.886,0-2.828,0-3.414.586S6.5,9.114,6.5,11v.5c0,1.886,0,2.828.586,3.414s1.529.586,3.414.586h3c1.886,0,2.828,0,3.414-.586s.586-1.529.586-3.414V11c0-1.886,0-2.828-.586-3.414S15.386,7,13.5,7Z",
    fill: "none",
    stroke: "#d86a2d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29189",
    "data-name": "Path 29189",
    d: "M9,7V5a3,3,0,0,1,6,0V7",
    fill: "none",
    stroke: "#d86a2d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29190",
    "data-name": "Path 29190",
    d: "M13.5,19l-3,3m0-3,3,3",
    fill: "none",
    stroke: "#d86a2d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29191",
    "data-name": "Path 29191",
    d: "M21,19l-3,3m0-3,3,3",
    fill: "none",
    stroke: "#d86a2d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29192",
    "data-name": "Path 29192",
    d: "M6,19,3,22m0-3,3,3",
    fill: "none",
    stroke: "#d86a2d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountSetupIcon);
export default __webpack_public_path__ + "static/media/accountSetupIcon.ec667f94fd549b5296719a1da34c3ccc.svg";
export { ForwardRef as ReactComponent };